export default {
  init() {
    // JavaScript to be fired on the home page
    $('.home_slick').slick(
      {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 6000,
        dots: false,
        infinite: false,
      }
    );
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js